


































import {Component, Prop, Watch} from 'vue-property-decorator';
import BaseComponent from '@/core/components/BaseComponent';
import {Api} from "@/core/services/MedicaPro/Api";
import bus from "@/main";
import {Client, Measurement, MeasurementTypeConfiguration} from "@/core/services/MedicaPro/models";
import MeasurementListCreateNewRow
    from "@/components/Admin/Clients/Details/Components/MeasurementList/Components/MeasurementList-CreateNew-Row.vue";
import {CountRunner} from "@/helpers/CountRunner";

@Component({
    components: {
        MeasurementListCreateNewRow

    }
})
export default class MeasurementListCreateNew extends BaseComponent {

    // Bindings to parent
    @Prop() client!: Client;
    @Prop() category?: string;

    // Bindings to view
    public isReady = false;
    public items: {measurementIdentifier: string, measurementTypeConfiguration?: MeasurementTypeConfiguration}[] = [];

    public mounted() {
        this.renderView();
    }

    public beforeDestroy() {
        super.beforeDestroy();
    }

    private renderView() {
        let identifiers: string[];
        let configurations: MeasurementTypeConfiguration[];

        const countRunner = new CountRunner(2);
        countRunner.setRunner(() => {
            this.items = identifiers.map(identifier => {
                return {
                    measurementIdentifier: identifier,
                    measurementTypeConfiguration: configurations.find(configuration => {
                        return configuration.measurement_identifier == identifier
                            && configuration.typeform_identifier?.length;
                    })
                };
            });
            this.isReady = true;
        });

        Api.measurementTypes().identifiersGetGet()
            .category(this.category ?? 'all')
            .find((values: string[]) => {
                identifiers = values;
                countRunner.increment();
            });
        Api.measurementTypeConfigurations().get()
            .find(measurementTypeConfigurations => {
                configurations = measurementTypeConfigurations;
                countRunner.increment();
            });
        countRunner.start();
    }

    public createItem(measurementTypeIdentifier: string) {
        bus.$emit(
            `measurementEdit`,
            Measurement.Create(this.client, measurementTypeIdentifier)
        );
    }

}
